export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex items-start justify-between gap-4 mb-6">
    <div>
      <h1 className="font-heading font-bold text-2xl sm:text-3xl text-[#0D3B2D]">{title}</h1>
      {subtitle && <p className="text-sm text-[#4A635A] mt-1">{subtitle}</p>}
    </div>
    {children}
  </div>
);

export const StatusPill = ({ status }) => {
  const map = {
    paid: "bg-[#F4FFF9] text-[#10B981] border-[#BCECD8]",
    active: "bg-[#F4FFF9] text-[#10B981] border-[#BCECD8]",
    pending: "bg-amber-50 text-amber-600 border-amber-200",
    payment_pending: "bg-amber-50 text-amber-600 border-amber-200",
    invited: "bg-sky-50 text-sky-600 border-sky-200",
    unpaid: "bg-amber-50 text-amber-600 border-amber-200",
    past_due: "bg-red-50 text-red-600 border-red-200",
    suspended: "bg-red-50 text-red-600 border-red-200",
    initiated: "bg-slate-50 text-slate-500 border-slate-200",
    draft: "bg-slate-50 text-slate-500 border-slate-200",
    failed: "bg-red-50 text-red-600 border-red-200",
    canceled: "bg-slate-100 text-slate-500 border-slate-200",
    expired: "bg-slate-100 text-slate-500 border-slate-200",
    archived: "bg-slate-100 text-slate-400 border-slate-200",
    completed: "bg-[#F4FFF9] text-[#10B981] border-[#BCECD8]",
    resolved: "bg-[#F4FFF9] text-[#10B981] border-[#BCECD8]",
    open: "bg-amber-50 text-amber-600 border-amber-200",
  };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border capitalize ${map[status] || "bg-slate-50 text-slate-500 border-slate-200"}`}>
      {(status || "—").replace("_", " ")}
    </span>
  );
};

export const EmptyState = ({ icon: Icon, title, hint }) => (
  <div className="bg-white border border-dashed border-[#E2EBF0] rounded-xl py-16 text-center">
    {Icon && <Icon className="h-8 w-8 text-[#BCECD8] mx-auto mb-3" />}
    <p className="font-heading font-semibold text-[#0D3B2D]">{title}</p>
    {hint && <p className="text-sm text-[#4A635A] mt-1">{hint}</p>}
  </div>
);
